<template>
  <aside :class="{sidebar: true, toggled: sidebarVisible}">
    <div class="scrollbar-inner" ref="scroll_block">
      <div class="user">
        <div class="user__info" data-toggle="dropdown">
          <img class="user__img" :src="avatar_url" alt="">
          <div>
            <div class="user__name" v-text="sp_contactor"></div>
            <div class="user__email" v-text="spname"></div>
          </div>
        </div>

        <div :class="{'dropdown-menu': true, show: showUserDropDownMenu}">
          <router-link class="dropdown-item" :to="{ name: 'SpInfo', params: {}}">我的信息</router-link>
          <a class="dropdown-item" href="javascript:void(0)" @click="logout_session">退出登录</a>
        </div>
      </div>

      <ul class="navigation">
        <template v-for="menu in menus">
          <template v-if="!menu.sub_menus || !menu.sub_menus.length">
            <router-link v-if="!menu.show || menu.show()" tag="li" exact :to="menu.to"
                         @click.native="handleToggleAllMenu">
              <a><i :class="menu.icon"></i> {{ menu.label }}</a>
            </router-link>
          </template>
          <template v-if="menu.sub_menus && menu.sub_menus.length && (!menu.show || menu.show())">
            <li
              :class="{
            navigation__sub: true,
            'navigation__sub--active': current_path.substr(0,menu.prefix.length).toLowerCase() === menu.prefix,
            'navigation__sub--toggled': menu.toggled
          }"
              @click="handleToggleSubMenu(menu)">
              <a><i :class="menu.icon"></i> {{ menu.label }}</a>
              <ul :style="menu.toggled ? '' : 'display: none'" @click="handleToggleSubMenu(menu)">
                <router-link tag="li" v-if="!submenu.show || submenu.show()" :to="submenu.to"
                             v-for="submenu in menu.sub_menus" :key="submenu.label">
                  <a v-text="submenu.label"></a>
                </router-link>
              </ul>
            </li>
          </template>
        </template>
      </ul>
    </div>
  </aside>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import {logout} from '../../utils/auth';

export default {
  components: {},
  data() {
    return {
      showUserDropDownMenu: false,
      menus: [
        {to: {name: 'Dashboard'}, icon: 'zmdi zmdi-home', label: '工作台'},
        {to: {name: 'Tickets'}, icon: 'zmdi zmdi-view-list', label: '报修单'},
        {to: {name: 'RepairMember'}, icon: 'zmdi zmdi-accounts', label: '报修会员'},
        {to: {name: 'RepairForm'}, icon: 'zmdi zmdi-check-square', label: '报修表单'},
        {to: {name: 'RepairTemplate'}, icon: 'zmdi zmdi-widgets', label: '报修模板'},
        {
          label: '微信公众号',
          icon: 'zmdi zmdi-center-focus-strong',
          prefix: '/wechat',
          toggled: false,
          show: () => false,
          sub_menus: [
            {to: {name: 'WeChat'}, label: '配置'},
            {to: {name: 'WeChatMenuOld'}, label: '公众号菜单'},
            {to: {name: 'WeChatSubscribeReply'}, label: '关注回复'},
          ]
        },
        {
          label: '微信授权公众号',
          icon: 'zmdi zmdi-center-focus-strong',
          prefix: '/authorizer',
          toggled: false,
          show: () => true,
          sub_menus: [
            {to: {name: 'WeChatAuthorizerMenu'}, label: '授权公众号列表'},
            {to: {name: 'WeChatMenu'}, label: '公众号菜单'},
          ]
        },
        {
          to: {name: 'Binding'},
          icon: 'zmdi zmdi-8tracks',
          label: '系统集成',
          toggled: false,
          show: () => +this.info_spec === 2 || +this.info_spec === 0
        },
        {to: {name: 'AccountInfo'}, icon: 'zmdi zmdi-money', label: '我的账户'},
        {to: {name: 'SpInfo'}, icon: 'zmdi zmdi-account', label: '我的信息'},
        {to: {name: 'SpSetting'}, icon: 'zmdi zmdi-settings', label: '设置'},
        {
          label: '应用设置',
          icon: 'zmdi zmdi-layers',
          prefix: '/app',
          toggled: false,
          sub_menus: [
            {to: {name: 'DashboardSetting'}, label: '服务台轮播图设置'},
            {to: {name: 'DashboardShortcut'}, label: '服务台快捷选项设置'},
            {to: {name: 'Announcement'}, label: '公告'},
            {to: {name: 'ServiceBranch'}, label: '服务网点'},
            {to: {name: 'ChargeSpec'}, label: '收费标准'},
            {to: {name: 'DevicePresentView'}, label: '机器展示页面'},
          ]
        },
        {
          label: '管理功能',
          icon: 'zmdi zmdi-code',
          prefix: '/mgr',
          toggled: false,
          show: () => +this.sp_id === 1,
          sub_menus: [
            {to: {name: 'SubDomainAudit'}, label: '子域名审核'},
            {to: {name: 'CustomerDomainAudit'}, label: '客户域名审核'},
            {to: {name: 'ServiceProviderMgr'}, label: '注册服务商管理'},
            {to: {name: 'RevenueExpenditure'}, label: '服务商充值记录'},
            {to: {name: 'MiniAppView'}, label: '小程序管理'},
            {to: {name: 'FeedbackView'}, label: '用户反馈'},
            {to: {name: 'CompileAppView'}, label: 'APP发布'},
          ]
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'sp_contactor',
      'spname',
      'sp_id',
      'avatar',
      'topbarVisible',
      'sidebarVisible',
      'info_spec',
      'info_logo',
      'info_use_we_chat_third_party_platform'
    ]),
    ...mapState({
      route: state => state.route,
      current_path: state => state.route.path,
    }),
    avatar_url: {
      get() {
        return this.info_logo || require('../../assets/img/profile-pics/8.jpg');
      }
    }
  },
  watch: {
    current_path: {
      handler() {
        this.menus.forEach((item, index) => {
          if (item.prefix) {
            this.$set(this.menus, index, {
              ...item,
              toggled: this.current_path.substr(0, item.prefix.length).toLowerCase() === item.prefix
            });
          }
        });
      }
    }
  },
  methods: {
    logout_session() {
      logout();
    },
    handleToggleSubMenu(menu) {
      menu.toggled = !menu.toggled;
    },
    handleToggleAllMenu() {
      this.menus.forEach(menu => menu.toggled = false);
    },
    resetScroll() {
      $(this.$refs.scroll_block).slimScroll({
        height: $(window).height() - 80,
        railOpacity: 0.9,
        alwaysVisible: false
      });
    }
  },
  beforeCreated() {
  },
  mounted() {
    this.$nextTick(() => {
      this.resetScroll();

      $(window).resize(() => {
        this.resetScroll();
      });
    });
  }
}
</script>

<style lang="scss">
@import "../../assets/scss/inner-imports";

@mixin sidebar-toggled() {
  background-color: $white;
  @include transition(transform 300ms, opacity 300ms);

  &:not(.toggled) {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

  &.toggled {
    box-shadow: 5px 0 10px rgba($black, 0.08);
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.sidebar {
  width: $sidebar-width;
  position: fixed;
  left: 0;
  padding: ($header-height + $grid-gutter-width) 2rem 0.5rem 2rem;
  height: 100%;
  overflow: hidden;
  z-index: $sidebar-z-index;

  @include media-breakpoint-down(lg) {
    @include sidebar-toggled();
  }

  // Scrollbar position
  .scrollbar-inner > .scroll-element {
    margin-right: 0;
  }
}

.sidebar--hidden {
  @include sidebar-toggled();
}

// User
.user {
  background-color: $navigation-link-hover-bg;
  border-radius: $border-radius;
  margin: 0 0 1.5rem 0;
  position: relative;

  .dropdown-menu {
    width: 100%;
    transform: none !important;
  }
}

.user__info {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  font-size: 0.9rem;
  padding: 0.8rem;
  border-radius: $border-radius;
  @include transition(background-color 300ms);

  &:hover {
    background-color: $navigation-link-hover-bg;
  }
}

.user__img {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  margin-right: 0.8rem;
}

.user__name {
  color: $headings-color;
  font-weight: $font-weight-bold;
}

.user__email {
  color: lighten($body-color, 15%);
}

// Site Navigation
.navigation {
  list-style: none;
  padding: 0;

  li {
    a {
      color: $navigation-link-color;
      @include transition(background-color 300ms, color 300ms);
      font-weight: $font-weight-bold;
      display: block;
    }

    &:not(.navigation__active):not(.navigation__sub--active) {
      a {
        &:hover {
          background-color: $navigation-link-hover-bg;
          color: darken($navigation-link-color, 10%);
        }
      }
    }
  }

  & > li {
    & > a {
      padding: 0.85rem 0.5rem;
      position: relative;
      border-radius: $border-radius;

      & > i {
        vertical-align: top;
        font-size: 1.3rem;
        position: relative;
        top: 0.1rem;
        width: 1.5rem;
        text-align: center;
        margin-right: 0.6rem;
      }
    }
  }
}

.navigation__sub {
  & > ul {
    border-radius: $border-radius;
    list-style: none;
    overflow: hidden;
    padding: 0;

    & > li {
      & > a {
        padding: 0.6rem 1rem 0.6rem 2.75rem;
      }

      &:last-child {
        padding-bottom: 0.8rem;
      }
    }
  }

  /*&:not(.navigation__sub--active) {*/
  /*& > ul {*/
  /*display: none;*/
  /*}*/
  /*}*/

  .navigation__active {
    position: relative;

    &:before {
      @include font-icon('\f26d', 6px);
      position: absolute;
      left: 1rem;
      top: 0.7rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/app-sidebar.vue